module.exports = __webpack_public_path__ + "static/21-ee1746f2b3ca150f1fa507fb7bb129b0.jpg";